import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type DiscoveryV2SearchHistoryStoreState = {
  searchHistory: string[];
};

type DiscoveryV2SearchHistoryStoreActions = {
  add: (value: string) => void;
  reset: () => void;
};

const initialDiscoveryV2SearchHistoryStoreState: DiscoveryV2SearchHistoryStoreState =
  {
    searchHistory: [],
  };

export const useDiscoveryV2SearchHistoryStore = create<
  DiscoveryV2SearchHistoryStoreState & DiscoveryV2SearchHistoryStoreActions
>()(
  persist(
    (set) => ({
      ...initialDiscoveryV2SearchHistoryStoreState,
      add: (searchValue) =>
        set(({ searchHistory: prev }) => {
          if (searchValue === "")
            return {
              searchHistory: prev,
            };
          return {
            searchHistory: [searchValue, ...prev].slice(0, 6),
          };
        }),
      reset: () => set(initialDiscoveryV2SearchHistoryStoreState),
    }),
    {
      name: "discoverySearchHistory",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        searchHistory: state.searchHistory,
      }),
    },
  ),
);
